var _rect, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEj00(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.13,
    y: 0.98,
    width: 3.75,
    height: 14.74,
    rx: 1.13,
    ry: 1.13
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 19.8,
    r: 1.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.34,12.12h-1.45v-.64c0-.41-.34-.75-.75-.75h-8.26v1.5h7.51v15.29H7.36v-15.29h5.76v-1.5h-6.51c-.41,0-.75.34-.75.75v.64h-2.2c-.41,0-.75.34-.75.75v3.83H.66c-.41,0-.75.34-.75.75v4.85c0,.41.34.75.75.75h2.25v3.83c0,.41.34.75.75.75h2.2v.64c0,.41.34.75.75.75h20.52c.41,0,.75-.34.75-.75v-.64h1.45c.41,0,.75-.34.75-.75v-14.01c0-.41-.34-.75-.75-.75ZM2.86,21.55h-1.45v-3.35h1.45v3.35Zm3,4.58h-1.45v-12.51h1.45v12.51Zm22.72,0h-.7v-12.51h.7v12.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEj00);
export default __webpack_public_path__ + "static/media/EJ00.a2a7b104f2c3741814cbbb3dcc2feea3.svg";
export { ForwardRef as ReactComponent };